import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';
import { EidEasySigningMethod } from '@dealstack/shared/lib/common/eideasy/signingMethods';

export interface MethodOption {
	method: EidEasySigningMethod;
	icon: PredefinedIcons;
	labelKey: string;
	descriptionKey: string;
}

export const METHOD_OPTIONS: MethodOption[] = [
	{
		method: EidEasySigningMethod.SMART_ID,
		icon: 'smart-id',
		labelKey: 'eid_easy_signing.method_smart_id',
		descriptionKey: 'eid_easy_signing.method_smart_id_description',
	},
	{
		method: EidEasySigningMethod.FTN,
		icon: 'ftn',
		labelKey: 'eid_easy_signing.method_ftn',
		descriptionKey: 'eid_easy_signing.method_ftn_description',
	},
	{
		method: EidEasySigningMethod.OTP,
		icon: 'mail',
		labelKey: 'eid_easy_signing.method_otp',
		descriptionKey: 'eid_easy_signing.method_otp_description',
	},
	{
		method: EidEasySigningMethod.DRAW,
		icon: 'drawn-signature',
		labelKey: 'eid_easy_signing.method_draw',
		descriptionKey: 'eid_easy_signing.method_draw_description',
	},
	{
		method: EidEasySigningMethod.SE_BANKID,
		icon: 'bank',
		labelKey: 'eid_easy_signing.method_se_bankid',
		descriptionKey: 'eid_easy_signing.method_se_bankid_description',
	},
	{
		method: EidEasySigningMethod.NORWEGIAN_BANKID,
		icon: 'bank',
		labelKey: 'eid_easy_signing.method_no_bankid',
		descriptionKey: 'eid_easy_signing.method_no_bankid_description',
	},
	{
		method: EidEasySigningMethod.MITID,
		icon: 'bank',
		labelKey: 'eid_easy_signing.method_mitid',
		descriptionKey: 'eid_easy_signing.method_mitid_description',
	},
	{
		method: EidEasySigningMethod.FREJA,
		icon: 'badge',
		labelKey: 'eid_easy_signing.method_freja',
		descriptionKey: 'eid_easy_signing.method_freja_description',
	},
];
